/* eslint no-param-reassign: 0 */

import { flashErrorMessage } from './flash';

export function handleError(err, nextAction) {
  return (dispatch) => {
    let message = 'An error occurred';
    if (err.res && !err.res.ok) {
      const contentType = err.res.headers.get('Content-Type');
      if (contentType.includes('text/plain')) {
        return err.res.text().then((text) => {
          let notify = true;
          if (
            err.res.status === 400 ||
            err.res.status === 401 ||
            err.res.status === 403 ||
            err.res.status === 412
          ) {
            notify = false;
            message = text;
          }
          dispatch(nextAction());
          err.message = message.trim();
          if (notify) {
            Bugsnag.notifyException(err);
          }
          return Promise.reject(err);
        });
      }
      dispatch(nextAction());
      err.message = message;
      Bugsnag.notifyException(err);
      return Promise.reject(err);
    }
    const isAwsErr = err.message.match(/No current user/i);
    if (!isAwsErr) {
      dispatch(flashErrorMessage({ message }));
    }
    dispatch(nextAction());
    err.message = message;
    if (!isAwsErr) {
      Bugsnag.notifyException(err);
    }
    return Promise.reject(err);
  };
}

export function userErrorIdentity(payload) {
  Bugsnag.user = {
    id: payload.id,
    email: payload.email,
    name: payload.name,
  };
}



// WEBPACK FOOTER //
// ./src/actions/error.js